import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { adminLogin, fetchMe, setToken, clearToken, getToken } from "../lib/adminApi";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=logged
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      if (!getToken()) {
        setUser(false);
        setReady(true);
        return;
      }
      try {
        const me = await fetchMe();
        setUser(me);
      } catch {
        clearToken();
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await adminLogin(email, password);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, ready, login, logout }), [user, ready, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
